export default __webpack_public_path__ + "media/images/noshis/iwainoshimihon-9594e8086e1e7fcc1b78e5cf2f51197c.jpg";